import type { ReactElement } from 'react';
import DisplayItem from '@fastnorth/kraken/components/display-item';
import { Flex } from '@fastnorth/kraken/components/layout';
import { ExternalLink } from '@fastnorth/kraken/components/navigation';
import { H1, Paragraph, Pre } from '@fastnorth/kraken/components/typography';
import { useTranslation } from 'react-i18next';
import { RACEROSTER_HOME_URL } from '../../config/constants';

export type RedirectToExternalResultsUrlProps = {
  resultsUrl: string;
};

const RedirectToExternalResultsUrl = ({
  resultsUrl,
}: RedirectToExternalResultsUrlProps): ReactElement => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'karwa.components.provider.redirect_to_external_results_url',
  });

  return (
    <Flex className={'h-full w-full items-center justify-center pt-7 sm:pt-9'}>
      <Flex className={'w-1/2 flex-col'} gap={'6'}>
        <H1>{t('heading')}</H1>
        <Paragraph>
          {t('body')}{' '}
          <ExternalLink href={RACEROSTER_HOME_URL} variant={'inline'}>
            {t('brand')}
          </ExternalLink>{' '}
          {t('body_after')}
        </Paragraph>
        <DisplayItem
          title={t('destination_label')}
          contentSlot={[<Pre key={'destination-url'}>{resultsUrl}</Pre>]}
        />
        <Paragraph>
          {t('warning')}{' '}
          <ExternalLink href={RACEROSTER_HOME_URL} variant={'inline'}>
            {t('brand')}
          </ExternalLink>{' '}
          {t('warning_after')}
        </Paragraph>
        <ExternalLink
          href={resultsUrl}
          target={'_self'}
          rel={'nofollow'}
          variant={'pill'}
          accent={'primary'}>
          {t('continue_action')}
        </ExternalLink>
      </Flex>
    </Flex>
  );
};

export default RedirectToExternalResultsUrl;
